import React from 'react';

import './Pill.scss';

export type PillTone = 'neutral' | 'info' | 'accent' | 'success' | 'warning' | 'error';
export type PillSize = 'small' | 'default';

export interface PillProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: PillTone;
  size?: PillSize;
  leading?: React.ReactNode;
  trailing?: React.ReactNode;
}

/** Shared visual shell for compact labels, statuses, roles, and metadata. */
export function Pill({
  tone = 'neutral',
  size = 'default',
  leading,
  trailing,
  className = '',
  children,
  ...props
}: Readonly<PillProps>): React.ReactElement {
  const classes = ['pill', `pill--${tone}`, `pill--${size}`, className].filter(Boolean).join(' ');

  return (
    <span className={classes} {...props}>
      {leading && <span className="pill__leading">{leading}</span>}
      <span className="pill__label">{children}</span>
      {trailing && <span className="pill__trailing">{trailing}</span>}
    </span>
  );
}

export default Pill;
